import React from 'react';
import { useSelector } from 'react-redux';
import { isCompetitionEnded } from '../../../ui/builders/utils';
import { isCharedi, openInNewTab } from '../../../utils/utils';
import Button from './Button';
import iconsList from '../icons/iconsList';

const RegisterButton = ({ bgcolor, text, icon, className, ...props }) => {

  const { activeContests, currentContestId } = useSelector((state) => state.contest);
  const state = useSelector((state) => state.contest);
  const currentContest = activeContests?.find((c) => String(c.id) === String(currentContestId));
  const registerLink =  isCharedi() ? currentContest?.charediRegistrationLink : currentContest?.registrationLink;

  if (isCompetitionEnded(state) || !registerLink) {
    return null;
  }

  return (
    <Button
      onClick={() => openInNewTab(registerLink)}
      color={bgcolor || "#F2AD22"}
      text={text}
      iconName={icon || iconsList.registration}
      className={className}
      {...props}
    />
  );
};

export default RegisterButton;

